export default "__VITE_ASSET__Couvfcnk__"